const doc = [({"da":({"js":({"contacts":({"select":({"choose_contact":"Vælg kontakt"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;